// Module 6 / Slice 5 — Vehicle detail Positions tab.
//
// Lists crewing.crew_position rows for the current vehicle ordered by
// position_index. Drag-to-reorder UX is carry C-mod6-17 (Phase 4); v1
// ships the read + data-testid surface that Playwright + Vitest hook into.

import type { components } from "../../../api/crewing.gen";
import { useI18n } from "../../../i18n/I18nContext";

type CrewPosition = components["schemas"]["CrewPosition"];

export function PositionsTab({
  vehicleId,
  positions,
}: {
  vehicleId: string;
  positions: readonly CrewPosition[];
}): JSX.Element {
  const { t } = useI18n();
  if (positions.length === 0) {
    return (
      <p data-testid={`positions-tab-empty-${vehicleId}`}>
        {t("crewing.positions.empty")}
      </p>
    );
  }
  return (
    <table className="rc-table" data-testid="positions-tab-table">
      <thead>
        <tr>
          <th>{t("crewing.positions.col.index")}</th>
          <th>{t("crewing.positions.col.title")}</th>
          <th>{t("crewing.positions.col.roleCode")}</th>
        </tr>
      </thead>
      <tbody>
        {positions
          .slice()
          .sort((a, b) => a.positionIndex - b.positionIndex)
          .map((p) => (
            <tr key={p.id} data-testid={`position-row-${p.id}`}>
              <td data-testid={`position-index-${p.id}`}>{p.positionIndex}</td>
              <td data-testid={`position-title-${p.id}`}>{p.title}</td>
              <td>{p.roleCode ?? "—"}</td>
            </tr>
          ))}
      </tbody>
    </table>
  );
}
